module.exports = __webpack_public_path__ + "static/netAD-Figure1-80a49c2993e21ffa8ed96901fe9f026d.png";